<ng-container *ngIf="routerLink && !target; else buttonWithClick">
  <a
    [class]="buttonClass"
    [routerLink]="routerLink"
    [fragment]="fragment"
    [target]="target"
    (click)="disabled ? undefined : buttonClick.emit()"
    style="text-decoration: none; display: inline-block"
  >
    <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
  </a>
</ng-container>

<ng-template #buttonWithClick>
  <div
    [class]="buttonClass"
    (click)="
      disabled
        ? undefined
        : target
          ? routerLinkAction($event)
          : buttonClick.emit()
    "
    [style.display]="block ? 'block' : 'inline-block'"
    [style.width]="block ? '100%' : 'auto'"
    [style.height]="height"
    [class.button-font-size]="!!fontSize"
    [style.--font-size]="fontSize"
  >
    <ng-container *ngTemplateOutlet="buttonTemplate"></ng-container>
  </div>
</ng-template>

<ng-template #buttonTemplate>
  <p-button
    [class]="class"
    [class.button-font-size]="!!fontSize"
    [class.button-bg-white]="backgroundColor === 'white'"
    [class.button-bg-black]="backgroundColor === 'black'"
    [style.--font-size]="fontSize"
    [class.button-block]="block"
    [class.ghost-button]="ghost"
    [class.square-button]="square"
    [severity]="color"
    [size]="pButtonSize"
    [outlined]="outlined"
    [class.disabled]="faded || disabled"
    [disabled]="disabled"
    [label]="label"
    [pTooltip]="tooltipLabel"
    [tooltipPosition]="tooltipPosition"
    [icon]="icon"
    [text]="asText"
    [rounded]="pButtonSize === 'small'"
    [style.height]="height"
    [style.font-size]="fontSize"
  />
</ng-template>
